import script from "./prize.vue?vue&type=script&setup=true&lang=js"
export * from "./prize.vue?vue&type=script&setup=true&lang=js"

import "./prize.vue?vue&type=style&index=0&id=c6807bca&lang=less&scoped=true"

import exportComponent from "/data/jenkins_home/workspace/prod-AI-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c6807bca"]])

export default __exports__